import config from "@/config"
import http from "@/utils/request"
import { encrypt } from '@/utils/encrypt'
export default {
  token: {
    url: `${config.API_URL}/auth/signin`,
    // url: `${config.API_URL}/token`, //测试
    name: "登录获取TOKEN",
    post: async function (data = {}) {
      return await http.post(this.url, { ...data, password: encrypt(data.password) })
    }
  },
  user: {
    url: `${config.API_URL}/auth`,
    // url: `${config.API_URL}/token`, //测试
    name: "注册用户",
    registStoreUser: async function (data = {}) {
      return await http.post(`${this.url}/registerUser`, data)
    },
    loginBySmsCode: async function (data = {}) {
      return await http.post(`${this.url}/user/loginBySmsCode`, data)
    }
  },
  smsCode: {
    url: `${config.API_URL}/smsCode`,
    name: "发送验证码",
    getraphicCaptcha: async function (data = {}) {
      return await http.post(`${this.url}/captcha/getraphicCaptcha`, data)
    },
    sendSmsCode: async function (data = {}) {
      return await http.post(`${this.url}/user/captcha/sendSmsCode`, data)
    }
  }
}
